import { initializeApp } from "firebase/app";
import {
  getStorage,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  updateMetadata,
  ref,
} from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBnssma-tkbA_aWMnCY8nS6fSHMRlAfpHo",
  authDomain: "downfor-life.web.app",
  databaseURL: "https://downfor-life-default-rtdb.firebaseio.com",
  projectId: "downfor-life",
  storageBucket: "downfor-life.appspot.com",
  messagingSenderId: "711187192289",
  appId: "1:711187192289:web:fafc6d40d9115370bf9aa0",
  measurementId: "G-YWY283QDZ6"
};

initializeApp(firebaseConfig);

const getSourceRefFromDownloadURL = (downloadURL) => {
  try {
    // Parse the URL to extract the file path
    const url = new URL(downloadURL);
    const encodedPath = url.pathname.split("/o/")[1]; // Extract the encoded file path
    const decodedPath = decodeURIComponent(encodedPath); // Decode the file path

    // Create and return the source reference
    return decodedPath;
  } catch (error) {
    console.error("Failed to parse the Download URL:", error);
    throw error;
  }
};

export const moveFileInFirebase = async (url, destinationPath) => {
  const storage = getStorage();
  const sourcePath = getSourceRefFromDownloadURL(url);
  const sourceRef = ref(storage, `/${sourcePath}`);
  const destinationRef = ref(storage, destinationPath);

  try {
    const response = await fetch(url);
    const fileBlob = await response.blob();

    const snapshot = await uploadBytes(destinationRef, fileBlob, "data_url");

    await deleteObject(sourceRef);

    const imageUrl = await getDownloadURL(snapshot.ref);

    return imageUrl;
  } catch (error) {
    console.error('Error moving file:', error);
    throw error;
  }
};

export const uploadToFirebase = async (filePathAndName, file) => {
  if (file) {
    try {
      const storage = getStorage();

      // Define the path to the temp folder
      const folderPath = (filePathAndName + (!(String(filePathAndName).includes(".png")) && ".png"));
      const storageRef = ref(storage, folderPath);

      // Upload the file to Firebase
      const snapshot = await uploadBytes(storageRef, file, "data_url");
      const expirationDate = new Date().getTime() + 24 * 60 * 60 * 1000;  // Expire in 24 hours

      // Create file metadata to update
      const newMetadata = {
        cacheControl: 'public,max-age=300',
        contentType: 'image/png',
        customMetadata: {
          'expirationDate': expirationDate
        }
      };

      // Update metadata properties
      await updateMetadata(storageRef, newMetadata)

      const imageUrl = await getDownloadURL(snapshot.ref);

      return imageUrl;
    } catch (error) {
      throw error;
    }
  }
};

export const getBase64FromFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const compressImage = (file, quality = 0.7) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    const img = new Image();

    reader.onload = (e) => {
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        canvas.toBlob((blob) => {
          const compressedFile = new File([blob], file.name, { type: 'image/jpeg' });
          resolve(compressedFile);
        }, 'image/jpeg', quality); // quality between 0 and 1
      };
      img.src = e.target.result;
    };

    reader.readAsDataURL(file);
  });
};
